import * as React from 'react';
var WithKeepAliveContext = React.createContext({});
export default WithKeepAliveContext;
